// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remote-csv-card{display:flex}.remote-csv--dropdown{flex:0 0 300px;margin-right:8px}.remote-csv-url-input{flex:4;width:100%}", ""]);
// Exports
module.exports = exports;
